export default __webpack_public_path__ + "static/media/left_icon.64484538.png";